<template>
  <div class="column is-9">
    <transition name="fade">
      <!--
      <div v-if="isLoading" class="loading">
        <pulse-loader :loading="isLoading"></pulse-loader>
      </div>
      v-else apres
      -->
      <div v-if="searchResults && !isLoading" class="is-border is-radius-large has-bg-white content content-guide">
        <div class="column is-border-bottom is-paddingless-bottom">
          <h1>Résultat(s) recherche pour "{{ searchQuerry }}"</h1>
        </div>

        <div class="column entry">
          <div class="entry-content searchResults">
            <!--
            <div v-for="content in validContents" :id="content.id" :key="content.id">
              <div v-if="content.type === 'tip'" class="columns guide-focus-bloc is-info is-flex-mobile">
                <div class="column is-2-mobile is-2-tablet is-2-desktop is-1-widescreen is-1-fullhd has-text-centered">
                  <i class="fal fa-hand-peace fa-2x"></i>
                </div>
                <div class="column" v-html="content.html">
                </div>
              </div>
              <div v-else v-html="page.content"></div>
            </div>
            -->
            <ul class="liste-themes-guide columns is-gapless is-multiline is-margin-bottom-large">
              <li
                v-for="content in searchResults" :id="content.ID" :key="content.ID"
                class="column is-12"
              >
                <!--
                <div v-if="content.parentSlug" class="column">
                  <router-link :to="{ name: 'Topic', params: {topicId: content.parentSlug}}" >{{content.parent_title}}</router-link> > <router-link v-if="content.parentSlug" :to="{ name: 'Page', params: { pageId: content.slug, topicId : content.parentSlug }}" class="mainLink"><span>{{content.post_title}}</span></router-link>
                  <router-link :to="{ name: 'Page', params: { pageId: content.slug, topicId : content.parentSlug }}" class="excerptlink">
                    <em class="column" v-html="content.context"></em>
                  </router-link>
                </div>
                <div v-else class="column">
                  <router-link :to="{ name: 'Topic', params: {topicId: content.slug}}" class="mainLink"><span class="resultTitle" v-html="content.post_title"></span></router-link>
                  <router-link :to="{ name: 'Topic', params: {topicId: content.slug}}" class="excerptlink">
                    <em class="column" v-html="content.context"></em>
                  </router-link>
                </div>
                -->
                <router-link v-if="content.parentSlug" :to="{ name: 'Page', params: { pageId: content.slug, topicId : content.parentSlug } }" class="column">
                  {{ content.parent_title }} <i class="fal fa-chevron-right"></i> <span class="resultTitle" v-html="content.post_title"></span>
                  <em v-html="content.context"></em>
                </router-link>
                <router-link v-else :to="{ name: 'Topic', params: {topicId: content.slug}}" class="column">
                  <span class="resultTitle" v-html="content.post_title"></span>
                  <em v-html="content.context"></em>
                </router-link>
              </li>
            </ul>
          </div>
        </div>

        <div class="column is-border-top">
          <p>
            Cet article ne vous a pas aidé ?
            <a href="mailto:support@okgo.fr?subject=Message FAQ vadimm" target="_blank">
              Contactez-nous par mail
            </a>
          </p>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import { api } from '../cmsApi'
  // import PulseLoader from '../components/PulseLoader'

  export default {
    name: 'SearchResult',
    // components: { PulseLoader },
    data () {
      return {
        isLoading: false,
        searchResults: []
        // contents: []
      }
    },
    computed: {
      searchQuerry () {
        let querry = this.$route.params.searchQuerry
        return querry // récuperre la searchQuerry dans la route -  route changé en result/:querry dans router.js qd imput de MySerchBar changé
      },
      /*
      validContents () {
        return this.contents
      },
      */
    },
    watch: {
      $route: 'initComponent'
    },
    created () {
      this.initComponent()
    },
    methods: {
      async initComponent () {
        this.isLoading = true
        if (api.isInit === false) {
          await api.init()
        }
        console.log('>>> fetchPage('+this.searchQuerry+')') // lance requette ds le cms sur ce résultat (ds cmsApi.js)

        if( this.searchQuerry != '' && this.searchQuerry != 'undefined' ){
          let wp_searchResults = await api.fetchSearchResults(this.searchQuerry)
          this.searchResults = wp_searchResults['data']
        }

        this.isLoading = false
      }
    }
  }
</script>

<style lang="css" scoped>

  a.editBtn{ position:absolute;right:40px;top:30px; }

  div.guide-focus-bloc a {
    color: white !important;
    text-decoration: none !important;
  }

  .fade-enter-active, .fade-leave-active {
      transition: opacity .3s, transform .3s;
      /* transform: translateX(0px); */
  }
  .fade-enter{
      opacity: 0;
      /* transform: translateX(-20px); */
  }
  .fade-leave-to{
      opacity: 0;
      /* transform: translateX(40px); */
  }

  .content-guide .liste-themes-guide li a:hover span:after{ margin: .4rem 0 0 .8rem !important; }


  .searchResults ul li a:hover{ text-decoration: none !important; }
  /* .searchResults ul li a:hover span.resultTitle{ text-decoration: underline !important; } */
  .searchResults ul li a span.resultTitle{ display: inline-block; }
  .searchResults ul li a:hover em{ text-decoration: none !important; }
  .searchResults ul li em{ display:block; }
  /*
  .mainLink{display:inline-block;}
  .searchResults ul li:hover.mainLink{ text-decoration: underline !important; }
  .searchResults ul li a.excerptlink:hover{ text-decoration: none !important; }
  */
  .fal{ margin: 0 0.5rem 0 0.3rem;  }

  .searchResults ul li a[data-v-28a7b29f]:hover {
    text-decoration: none !important;
    background: #f7f7f7;
  }

</style>

<style>
  strong.highlight {
    /*
    background: #5db4eb !important;
    padding: 2px 3px !important;
    color: #fff !important;
    */

    /* color: #5db4eb !important; */
    color: #000 !important;
    font-weight: 600 !important;
  }
</style>
